export default "__VITE_ASSET__D53n7r0G__";